import { LogoMark } from "./Scoreboard";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] text-white border-t border-white/10 py-8 px-4 sm:px-8 lg:px-16"
    >
      <div className="max-w-[1600px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <LogoMark className="w-6 h-6" />
          <span className="font-broadcast font-bold text-[10px] sm:text-xs tracking-[0.25em] uppercase">
            Advaith <span className="text-[#84E116]">vs</span> Life
          </span>
        </div>
        <p className="font-broadcast text-[10px] tracking-[0.2em] uppercase text-white/40">
          FT pending · © 2026 · Played with intent
        </p>
      </div>
    </footer>
  );
}
